import theme from '../assets/style/theme';
import generateRender from './generateRender';
export var getLinkTextClientColor = generateRender({
  hri: '#cda228',
  sga: '#f1894d',
  default: theme.palette.common[1]
});